import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { IconNames } from '../../shared/icon-name-paths';
import { SvgIconComponent } from '../icons/svg-icon/svg-icon.component';

@Component({
    selector: 'lib-text-with-icon',
    imports: [CommonModule, SvgIconComponent],
    templateUrl: './text-with-icon.component.html',
    styleUrl: './text-with-icon.component.css'
})
export class TextWithIconComponent {
    /* eslint-disable */
    iconName = input<IconNames>();
    iconColor = input<string>('var(--ion-color-orange');
}
